import React, { useState } from 'react';
import { CheckCircle2, Upload, ShieldCheck } from 'lucide-react';
import { agreementAPI, errorText } from './api';

const LABELS = {
  id_front: ['Driver licence — front', 'A clear photo of the front of your licence.'],
  id_back: ['Driver licence — back', 'A clear photo of the back of your licence.'],
  selfie: ['Verification photo', 'A photo of yourself holding your licence next to your face.'],
};

const UploadRow = ({ type, token, onDone, done }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const upload = async event => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) { setError('File too large. Maximum size is 10MB.'); return; }
    setBusy(true); setError('');
    try { const response = await agreementAPI.uploadId(token, type, file); onDone(type, response.data.data.id_verification); }
    catch (e) { setError(errorText(e)); }
    finally { setBusy(false); }
  };
  const [title, hint] = LABELS[type];
  return <div className="ag-document" data-testid={`id-upload-row-${type}`}>
    <div><strong>{title}</strong><p className="ag-muted">{hint}</p>{error && <p className="ag-id-error" data-testid={`id-upload-error-${type}`}>{error}</p>}</div>
    {done ? <span className="ag-id-done" data-testid={`id-upload-done-${type}`}><CheckCircle2 size={18}/>Uploaded</span>
      : <label className={`btn btn-outline ag-action${busy ? ' ag-disabled' : ''}`} data-testid={`id-upload-button-${type}`}>
        <Upload size={16}/>{busy ? 'Uploading…' : 'Choose photo'}
        <input type="file" hidden disabled={busy} accept={type === 'selfie' ? 'image/jpeg,image/png' : 'image/jpeg,image/png,application/pdf'} capture={type === 'selfie' ? 'user' : undefined} onChange={upload} data-testid={`id-upload-input-${type}`}/>
      </label>}
  </div>;
};

export const IdVerificationStep = ({ token, verification, onChange }) => {
  const [required] = useState(verification.missing);
  const [uploaded, setUploaded] = useState([]);
  if (verification.status === 'verified') return null;
  if (verification.status === 'pending' && !uploaded.length) return <section className="ag-section" data-testid="id-verification-pending">
    <h2>Identity verification</h2><p className="ag-muted"><ShieldCheck size={16}/> Your identification is on file and being reviewed by ST Books. Nothing more is needed from you.</p>
  </section>;
  const done = (type, next) => { setUploaded(previous => [...previous, type]); onChange(next); };
  return <section className="ag-section" data-testid="id-verification-step">
    <h2>Identity verification</h2>
    <p className="ag-muted" data-testid="id-verification-message">{verification.status === 'rejected'
      ? 'We couldn’t accept the identification you provided previously. Please upload new photos below before signing.'
      : 'Before signing, please provide your identification documents and a verification photo. This is only needed once.'}</p>
    <div className="ag-documents">{required.map(type => <UploadRow key={type} type={type} token={token} onDone={done} done={uploaded.includes(type)}/>)}</div>
    {verification.status === 'pending' && <p className="ag-muted" data-testid="id-verification-complete"><CheckCircle2 size={16} color="#178363"/> Thank you — your identification has been received for review.</p>}
  </section>;
};
